import DOMPurify from 'dompurify';
import { useMemo } from 'react';

import * as style from './style.module.css';

// Tags and attributes of the rich text written with the SlateEditor.
const ALLOWED_TAGS = ['p', 'br', 'h1', 'h2', 'h3', 'h4', 'h5', 'strong', 'em', 'u', 'ul', 'ol', 'li', 'a'];
const ALLOWED_ATTR = ['href', 'style', 'target', 'rel'];

// Dedicated DOMPurify instance, so that its hook does not apply to other users of the library.
const purifier = DOMPurify(window);
const TEXT_ALIGN = /^\s*text-align:\s*(left|right|center|justify)\s*;?\s*$/i;

purifier.addHook('afterSanitizeAttributes', (node) => {
    if (node.hasAttribute('style') && !TEXT_ALIGN.test(node.getAttribute('style'))) {
        node.removeAttribute('style');
    }
    if (node.tagName === 'A') {
        node.setAttribute('target', '_blank');
        node.setAttribute('rel', 'noopener noreferrer');
    }
});

/**
 * Renders rich text HTML (SlateEditor output) once cleaned by DOMPurify: only text formatting is
 * kept, and links open in a new tab. Renders nothing when the sanitizer is unavailable.
 */
const HtmlContent = ({ html = '', className = '' }) => {
    const cleanHtml = useMemo(() => {
        if (!purifier.isSupported) return '';
        return purifier.sanitize(html ?? '', { ALLOWED_TAGS, ALLOWED_ATTR, ALLOW_DATA_ATTR: false, ALLOW_ARIA_ATTR: false });
    }, [html]);

    return <div className={`${style.content} ${className}`} dangerouslySetInnerHTML={{ __html: cleanHtml }} />;
};

export default HtmlContent;
